import { notifications } from '@mantine/notifications';
import { printersService } from '../../../../../services/printers/printers.service';

// Polls the job and toasts the real result: printed (green) / failed (red) / pending (info).
export async function toastReceiptPrintResult(
  tenantId: string,
  jobId: number,
  employeeSession: string,
): Promise<void> {
  const result = await printersService.pollPrintJobResult(tenantId, jobId, employeeSession);
  if (result === 'printed') {
    notifications.show({ color: 'green', title: 'הדפסה', message: 'הקבלה הודפסה בהצלחה', autoClose: 3000 });
  } else if (result === 'failed') {
    notifications.show({ color: 'red', title: 'ההדפסה נכשלה', message: 'הקבלה לא הודפסה', autoClose: 3000 });
  } else {
    notifications.show({ color: 'blue', title: 'הדפסה', message: 'הקבלה נשלחה להדפסה (ממתין לאישור)', autoClose: 3000 });
  }
}

// Polls several receipt jobs and toasts once: green if all printed, red if any failed.
export async function toastReceiptPrintResults(
  tenantId: string,
  jobIds: number[],
  employeeSession: string,
): Promise<void> {
  if (jobIds.length === 1) {
    return toastReceiptPrintResult(tenantId, jobIds[0], employeeSession);
  }
  const results = await Promise.all(
    jobIds.map((jobId) => printersService.pollPrintJobResult(tenantId, jobId, employeeSession)),
  );
  if (results.some((result) => result === 'failed')) {
    notifications.show({ color: 'red', title: 'ההדפסה נכשלה', message: 'חלק מהקבלות לא הודפסו', autoClose: 3000 });
  } else if (results.every((result) => result === 'printed')) {
    notifications.show({ color: 'green', title: 'הדפסה', message: `${jobIds.length} קבלות הודפסו בהצלחה`, autoClose: 3000 });
  } else {
    notifications.show({ color: 'blue', title: 'הדפסה', message: 'הקבלות נשלחו להדפסה (ממתין לאישור)', autoClose: 3000 });
  }
}
